var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.33 21.5614V25.5614C28.3315 25.9328 28.2554 26.3003 28.1067 26.6406C27.9579 26.9808 27.7397 27.2862 27.4661 27.5373C27.1925 27.7883 26.8694 27.9794 26.5177 28.0984C26.1659 28.2173 25.7932 28.2615 25.4233 28.2281C21.3204 27.7823 17.3793 26.3803 13.9167 24.1348C10.6951 22.0877 7.96377 19.3563 5.91666 16.1348C3.66329 12.6564 2.26098 8.69609 1.82332 4.57476C1.79 4.20605 1.83382 3.83445 1.95199 3.4836C2.07016 3.13275 2.26008 2.81035 2.50968 2.53693C2.75927 2.2635 3.06306 2.04504 3.40171 1.89546C3.74036 1.74588 4.10644 1.66845 4.47666 1.6681H8.47666C9.12373 1.66173 9.75105 1.89087 10.2417 2.31281C10.7323 2.73475 11.0528 3.32069 11.1433 3.96143C11.3122 5.24152 11.6253 6.4984 12.0767 7.7081C12.256 8.18533 12.2949 8.70398 12.1885 9.20261C12.0822 9.70123 11.8351 10.1589 11.4767 10.5214L9.78332 12.2148C11.6814 15.5528 14.4453 18.3167 17.7833 20.2148L19.4767 18.5214C19.8392 18.1629 20.2969 17.9159 20.7955 17.8096C21.2941 17.7032 21.8128 17.742 22.29 17.9214C23.4997 18.3728 24.7566 18.6859 26.0367 18.8548C26.6843 18.9461 27.2759 19.2724 27.6987 19.7714C28.1215 20.2705 28.3462 20.9075 28.33 21.5614Z",
    stroke: "#343373",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpp);
export default __webpack_public_path__ + "static/media/spp.476f0ffa45f2f95a06b3724bf0c266a1.svg";
export { ForwardRef as ReactComponent };